import axios from "axios";
import axiosInstance from "./axiosConfig";
 
// Axios aislado para uploads directos a S3
const s3Axios = axios.create();
 
/**
 * Generar URL de subida.
 * @param {File} file
 * @param {string} subfolder - ruta relativa a ENV, ej: "RH" o "RH/Contratos"
 */
export async function getUploadUrl(file, subfolder = "") {
  const response = await axiosInstance.post("/files/upload-url", {
    fileType: file.type,
    fileName: file.name,
    subfolder,
  });
  return response.data;
}
 
/**
 * Subida directa a S3
 */
export async function uploadToS3(uploadUrl, file) {
  return await s3Axios.put(uploadUrl, file, {
    headers: { "Content-Type": file.type },
  });
}
 
/**
 * URL de visualización
 */
export async function getViewUrl(key) {
  const response = await axiosInstance.get(
    `/files/view/${encodeURIComponent(key)}`
  );
  return response.data;
}

export async function getDownloadUrl(key) {
  const response = await axiosInstance.get(
    `/files/download/${encodeURIComponent(key)}`
  );
  return response.data;
}
 
/**
 * Listado de archivos — filtra por prefix en el backend
 * @param {string} prefix - ej: "branchId/evidencias/" — el prefix RELATIVO a ENV
 */
export async function listFiles(prefix = "") {
  const params = new URLSearchParams();
  if (prefix) {
    params.append("prefix", prefix);
  }
  
  const response = await axiosInstance.get(
    `/files/list${params.toString() ? "?" + params.toString() : ""}`
  );
  return response.data;
}
 
/**
 * Renombrar archivo
 */
export async function renameFile(key, newName) {
  const response = await axiosInstance.post("/files/rename", { key, newName });
  return response.data;
}
 
/**
 * Obtener subcarpetas de un prefix.
 * El backend espera un prefix RELATIVO a ENV (sin "development/").
 *
 * Ej:
 *  input: "RH/Contabilidad/"
 *  output: [{ name: "Contratos", prefix: "RH/Contabilidad/Contratos/" }]
 */
export async function getAvailableFolders(s3Prefix = "") {
  // Normalización defensiva del input
  const cleanPrefix = s3Prefix.replace(/^\/+|\/+$/g, "");

  const response = await axiosInstance.get("/files/folders", {
    params: cleanPrefix ? { prefix: cleanPrefix } : {},
  });

  const names = Array.isArray(response.data) ? response.data : [];

  // Construcción determinista del árbol de navegación
  return names.map((name) => ({
    name,
    prefix: cleanPrefix ? `${cleanPrefix}/${name}/` : `${name}/`,
  }));
}
 
/**
 * Crear carpeta virtual en S3.
 * @param {string} folderPath - ruta relativa a ENV, ej: "RH" o "RH/Contratos"
 */
export async function createFolder(folderPath) {
  const response = await axiosInstance.post("/files/create-folder", {
    folderPath,
  });
  return response.data;
}
 
/**
 * Descarga de carpeta como ZIP.
 * @param {string} s3Prefix - prefix S3 completo, ej: "development/RH/"
 */
export const downloadFolder = async (s3Prefix) => {
  // El backend agrega ENV/ internamente, así que le pasamos solo lo relativo
  const ENV_PREFIX = `${process.env.REACT_APP_ENV || "development"}/`;
  const relativePrefix = s3Prefix.startsWith(ENV_PREFIX)
    ? s3Prefix.replace(ENV_PREFIX, "")
    : s3Prefix;
 
  const response = await axiosInstance.get("/files/download-folder", {
    params: { prefix: relativePrefix },
    responseType: "blob",
  });
 
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  const safeName = relativePrefix?.replace(/\//g, "_").replace(/_$/, "") || "folder";
  link.setAttribute("download", `${safeName}.zip`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
 